<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="solid" (click)="cancel()">
        <ion-icon slot="start" name="close-circle-outline"></ion-icon>
        {{ "General.Cancel" | translate }}
      </ion-button>
    </ion-buttons>
    <ion-title class="address-form-title">{{ title | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <!-- <div>
  <shared-postal-code-form
    [isReservation]="isReservation"
    [skipProvinceValidation]="skipProvinceValidation"
    (onPostalCodeValidated)="onPostalCodeValidated($event)"
  ></shared-postal-code-form>
</div> -->

@if (partialAddresses.length > 0) {
  <div>
    <shared-address-form
      (onAddressValidate)="onAddressValidate($event)"
      [partialAddresses]="partialAddresses"
      >
    </shared-address-form>
  </div>
}
</ion-content>
